import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface SupplierUserRolePermission {
  supplier_user_role_permission_id: number
  user_role_id: number
  module: string
  allowed_action: string[]
  created_at: string
  updated_at: string
}

interface SupplierUserRolePermissionListResponse {
  success: boolean
  data: SupplierUserRolePermission[]
  error?: {
    code: string
    message: string
  }
}

export function useSupplierUserRolePermissionByRoleId(roleId: number, enabled: boolean = true) {
  const { token } = useAuth()

  const { data, error, isLoading, mutate } = useGet<SupplierUserRolePermissionListResponse>(
    token && enabled ? `/api/supplier-user-role-permissions/role/${roleId}` : null,
    undefined,
    token ?? '',
    undefined,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      shouldRetryOnError: false,
    },
  )

  return {
    permissions: data?.data ?? [],
    isLoading: enabled ? isLoading : false,
    isError: enabled ? error : null,
    mutate,
  }
}
